module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hor-menu hor-menu-light hidden-sm hidden-xs"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, _vm._l((_vm.menu.horizontal), function(item, index) {
    return _c('li', {
      staticClass: "classic-menu-dropdown",
      class: {
        active: _vm.ui.activeTag === item.tag
      }
    }, [_c('a', {
      attrs: {
        "href": "javascript:;"
      },
      on: {
        "click": function($event) {
          return _vm.strike(item.tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(item.name) + "\n      ")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5df14331!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/horizontalmenu.vue
// module id = 415
// module chunks = 2